// The application backdrop uses the warmer orange and cooler blue tones from
// the Home experience. Keeping it in one place prevents individual pages from
// slowly drifting into slightly different shades of grey or lavender. The
// colour sits at the edges of the canvas so content stays calm and readable,
// while the app still feels recognisably AboutWork before a card is opened.
export const APP_BACKGROUND = [
  'radial-gradient(90% 76% at -14% -24%, rgba(240, 130, 76, 0.68) 0%, rgba(252, 184, 119, 0.34) 42%, transparent 70%)',
  'radial-gradient(84% 82% at 113% -16%, rgba(51, 107, 204, 0.60) 0%, rgba(132, 99, 197, 0.31) 45%, transparent 71%)',
  'radial-gradient(76% 78% at 106% 112%, rgba(245, 129, 70, 0.48) 0%, rgba(255, 183, 112, 0.18) 42%, transparent 72%)',
  'radial-gradient(72% 82% at -12% 110%, rgba(58, 120, 215, 0.44) 0%, rgba(130, 168, 234, 0.18) 44%, transparent 72%)',
  'linear-gradient(143deg, #EEEAF8 0%, #FFF6ED 47%, #FAF1EF 72%, #EDF2FC 100%)',
].join(', ')
